export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_25.d8b5bec9.jpg";